import MetaTags from "../../components/MetaTags";
import CoursesAndOffersPage from "../../features/web/coursesAndOffers/CoursesAndOffersPage";

function CoursesAndOffers() {
    return (
        <>
            <MetaTags
                title="مستر شريف أسامة | محاضرات الشهر"
                description="صفحة محاضرات الشهر و العروض على منصة شريف أسامة لمادة اللغة العربية للثانوية العامة. استعرض محاضرات كل شهر و العروض لتحقيق التفوق الدراسي."
                image="/images/Thumbnail.webp"
                name="Mr Sherif-Osama"
            />
            <CoursesAndOffersPage />
        </>
    );
}

export default CoursesAndOffers;
